import LegalTemplate from './LegalTemplate.vue'

export default LegalTemplate
